import { render, staticRenderFns } from "./Presets.vue?vue&type=template&id=2536e662&scoped=true"
import script from "./Presets.vue?vue&type=script&lang=js"
export * from "./Presets.vue?vue&type=script&lang=js"
import style0 from "./Presets.vue?vue&type=style&index=0&id=2536e662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2536e662",
  null
  
)

export default component.exports